import React, {Component} from 'react';
import {Divider, Grid, Header, Label, Segment} from 'semantic-ui-react';

class ViewAdminUserDetails extends Component {
    render() {
        const user = this.props.selectedObject[0];
        return (
            <div>
                <Header textAlign='center' size='large'>User Details</Header>
                <Divider section/>
                <Grid stackable>
                    <Grid.Column width={8}>
                        <Segment style={{height: '100%'}}>
                            <Label color='blue' ribbon>
                                Account Details
                            </Label>
                            <Grid.Column width={8}>
                                <dl>
                                    <dt>Name:</dt>
                                    <dd>{user.name}</dd>
                                    <dt>Email:</dt>
                                    <dd>{user.email}</dd>
                                    <dt>Mobile Number:</dt>
                                    <dd>{user['mobile_number']}</dd>
                                </dl>
                            </Grid.Column>
                        </Segment>
                    </Grid.Column>
                    <Grid.Column width={8}>
                        <Segment style={{height: '100%'}}>
                        <Label color='blue' ribbon>
                            Address Details
                        </Label>
                        <Grid.Column width={8}>
                            <dl>
                                <dt style={{minHeight: '70px'}}>Full Address</dt>
                                <dd>{user.line1},{user.line2}<br/>{user.locality},{user.city}<br/>{user.country},{user.postcode}
                                </dd>
                            </dl>
                            <p></p>
                            <p></p>
                            <p></p>
                        </Grid.Column>
                    </Segment>
                    </Grid.Column>
                </Grid>
            </div>
        );
    }

}

export default ViewAdminUserDetails;


// WEBPACK FOOTER //
// ./src/views/user/admin/view_user_details.js